import React, { useState, useCallback } from 'react';
import WelcomeDownloadTour from './WelcomeDownloadTour';

const TOUR_DISMISSED_KEY = 'onboarding_tour_dismissed';

interface DownloadOnboardingProps {
  /** Show onboarding modal when user has not completed onboarding (is_onboarded === false) */
  showOnboarding: boolean;
  /** No longer used: download prompt is shown as a green dot next to Downloads in the sidebar until first device is registered */
  showNoDesktop?: boolean;
  pathname: string;
  /** Call after onboarding completed/skipped to refresh user (is_onboarded) */
  onOnboardingComplete: () => void;
}

const DownloadOnboarding: React.FC<DownloadOnboardingProps> = ({
  showOnboarding,
  pathname: _pathname,
  onOnboardingComplete,
}) => {
  const [tourClosed, setTourClosed] = useState(() => {
    try { return localStorage.getItem(TOUR_DISMISSED_KEY) === 'true'; } catch { return false; }
  });

  const handleCloseTour = useCallback(() => {
    try { localStorage.setItem(TOUR_DISMISSED_KEY, 'true'); } catch { /* ignore */ }
    setTourClosed(true);
  }, []);

  const handleComplete = useCallback(() => {
    try { localStorage.setItem(TOUR_DISMISSED_KEY, 'true'); } catch { /* ignore */ }
    onOnboardingComplete();
    setTourClosed(true);
  }, [onOnboardingComplete]);

  const shouldShowTour = showOnboarding && !tourClosed;

  return (
    <>
      {shouldShowTour && (
        <WelcomeDownloadTour onClose={handleCloseTour} onComplete={handleComplete} />
      )}
    </>
  );
};

export default DownloadOnboarding;
